import { render } from "./BhutanPage.vue?vue&type=template&id=05ec9148&scoped=true"
import script from "./BhutanPage.vue?vue&type=script&lang=js"
export * from "./BhutanPage.vue?vue&type=script&lang=js"

import "./BhutanPage.vue?vue&type=style&index=0&id=05ec9148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ec9148"]])

export default __exports__